import { formatISOTimeOrNull } from 'utils/dateUtils'

const output = {
  format: (value: any) => formatISOTimeOrNull(value) ?? '',
}

export default output
